module.exports = __webpack_public_path__ + "/build/web/images/lookbook@3x.db62fbf4da961375cf8313b7eff1bfc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/lookbook@3x.jpg
// module id = 168
// module chunks = 13